import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { useNavigate, useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/app-layout";
import InsertionOrdersTab from "./tabs/insertion-orders-tab";
import InvoicesTab from "./tabs/invoices-tab";
import BillingTab from "./tabs/billing-tab";
import { NavbarTab } from "src/components/layout/app-navbar";

const BillingPage = () => {
  useSetPageTitle('Billing');
  const navigate = useNavigate();

  const { tab } = useParams<{ tab?: string }>();

  const billingTabs: NavbarTab[] = [
    {
      id: '',
      key: 'billing',
      label: 'Billing',
    },
    {
      id: 'insertion-orders',
      key: 'insertion-orders',
      label: 'Insertion Orders',
    },
    {
      id: 'invoices',
      key: 'invoices',
      label: 'Invoices',
    },
  ];

  const validTabs = billingTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    navigate(`/billing/${tabId}`);
  };


  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/billing"
      navbarProps={{
        showBackButton: true,
        backPath: "/billing",
        tabs: billingTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)] overflow-hidden">
        {currentTab === '' && <BillingTab />}
        {currentTab === 'insertion-orders' && <InsertionOrdersTab />}
        {currentTab === 'invoices' && <InvoicesTab />}
      </div>
    </AppLayout>
  );
};

export default BillingPage;